<template>
  <div>
    <div>
      <van-nav-bar
        class="userNavBar"
        @click-left="onClickLeft"
        title="证件上传"
        left-arrow
      >
        <template #left>
          <van-icon name="../../../static/images/mobile/back.png" size="18" />
        </template>
      </van-nav-bar>
      <div class="faceintroduce">
        请上传本人有效的二代身份证照片。身份证照片仅供实名制认证，请放心
      </div>
    </div>
    <div class="box">
      <van-uploader :after-read="nationalFrontImage">
        <div class="nationalEmblem1">
          <img :src="frontImage" alt="" />
        </div>
      </van-uploader>
      <van-uploader :after-read="nationalBackImage">
        <div class="nationalEmblem2">
          <img :src="backImage" alt="" />
        </div>
      </van-uploader>
    </div>
    <div style="display: flex; justify-content: center">
      <van-button @click="idUpdate" type="danger">下一步</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      frontImage: "../../../static/images/mobile/portrait.png",
      backImage: "../../../static/images/mobile/nationalEmblem.png",
      type: localStorage.getItem("type"),
			userName:localStorage.getItem("mobile"),
			password1:localStorage.getItem("password"),
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    //上传正面照片
    nationalFrontImage(file) {
      let content = file.file;
      let formData = new FormData();
      formData.append("file", content);
      formData.append("uploadType", "image");
      formData.append("size", file.file.size);
      this.$api.formpost("/FileUpload/upload", formData, (res) => {
        if ((res.status = "success")) {
          this.frontImage = res.showAddress;
        }
      });
    },
    //上传反面照片
    nationalBackImage(file) {
      let content = file.file;
      let formData = new FormData();
      formData.append("file", content);
      formData.append("uploadType", "image");
      formData.append("size", file.file.size);
      this.$api.formpost("/FileUpload/upload", formData, (res) => {
        if ((res.status = "success")) {
          this.backImage = res.showAddress;
        }
      });
    },
    idUpdate() {
      let param = {};
      param.frontImage = this.frontImage;
      param.backImage = this.backImage;
      param.userId = localStorage.getItem("userId");
      this.$axiosPackag.getMessageByAxios(
        "POST",
        "/user/setIdcardImage",
        param,
        null,
        null,
        (resD) => {
          if (resD) {
            if (this.type == 1) {
              this.$axiosPackag.getMessageByAxios(
                "POST",
                "/user/h5login",
                {
                  userName: this.userName,
                  password1: this.password,
                },
                null,
                null,
                (resD) => {
                  if (resD) {
                    localStorage.setItem("loginUrl", resD);
                    Toast("登录成功");
                    this.$axiosPackag.getMessageByAxios(
                      "GET",
                      "/session/getSession",
                      null,
                      null,
                      null,
                      (resD) => {
                        if (resD) {
                          this.$sessionStore.initSession(resD);
                          this.$router.push({ path: "/mobileHome" });
                        }
                      }
                    );
                  }
                },
                (errorCall) => {}
              );
            } else {
              this.$router.push({
                path: "/mobileFaceVerification",
              });
            }
          }
        },
        (errorCall) => {}
      );
    },
  },
};
</script>

<style scoped>
.faceintroduce {
  margin-left: 0.426667rem;
  margin-top: 0.32rem;
  color: #555555;
  font-weight: 400;
  font-size: 0.373333rem;
}
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.nationalEmblem1 {
  width: 8.4rem;
  height: 4.853333rem;
  border-radius: 0.213333rem;
  margin-top: 0.96rem;
  margin-bottom: 0.533333rem;
  display: flex;
  /*水平居中*/
  justify-content: center;
  /*垂直居中*/
  align-items: center;
}
.nationalEmblem2 {
  width: 8.4rem;
  height: 4.853333rem;
  border-radius: 0.213333rem;
  margin-bottom: 0.533333rem;
  display: flex;
  /*水平居中*/
  justify-content: center;
  /*垂直居中*/
  align-items: center;
}
.nationalEmblem1 img {
  border-radius: 0.213333rem;
  width: 8.4rem;
  height: 4.853333rem;
}
.nationalEmblem2 img {
  border-radius: 0.213333rem;
  width: 8.4rem;
  height: 4.853333rem;
}
.van-button {
  width: 9.146667rem;
  height: 1.28rem;
  border-radius: 0.64rem;
}
</style>


// WEBPACK FOOTER //
// MobileCertificateUpload.vue?a30d5f7c